export const fetchTranslations = (store, text) => {
    return store.dispatch("fetchTranslations", text);
};
